import '../../../styles/InputChips.css'
import PorcentageIcon from '../../../media/felsv/dark_close_icon.svg'
import { Tooltip } from "../../../components/Tooltip/Tooltip";
import { useEffect, useState } from "react";

export default function InputChips (props: any) {
  const { chips, setChips, maxChips } = props;
  const [accionChip, setAccionChip] = useState(-1)

  const handleChange = (e: any) => {
    const cadenaSinComas = e.target.value?.replace(/,/g, '');
    props.onChange({ target: {name: props.name, value: cadenaSinComas}});
  }

  const handleChipsSeparator = (e: any) => {
    if (e.key === ',') {
      if (props.value?.length > 0 && !props.error && chips?.length < maxChips) {
        setChips([...chips, props.value?.trim()]);
        setAccionChip(0);
      }
    } else {
      setAccionChip(-1);
    }
  }

  const handleDeleteChip = (indexDelete: number) => {
    setChips(chips.filter((item: any, index:number) => index !== indexDelete));
    setAccionChip(1);
  }

  useEffect(() => {
    switch (accionChip) {
      case 0: // Agregar, dejar campo vacio
        props.onChange({ target: {name: props.name, value: ''}});
        break;
      default:
        break;
    }
  }, [accionChip])

  return(
    <div style={{display: 'flex', flexDirection: 'column', width: '100%'}} className='m input-label label-input'>
      <label htmlFor={props.name} className="field-label">
        {props.label}
        {props.required && <span style={{color: 'red'}}>*</span>}
      </label>
      <Tooltip content={chips?.length < maxChips ? 'Puede definir varios correos separandolos con la tecla coma (",")' : `Puede enviar a un máximo de 5 remitentes`}>
        <div className="chip-container">
          {
            chips?.map((item: any, index: any) => (
              <div className="chip__item">
                {item}
                <img onClick={() => handleDeleteChip(index)} src = {PorcentageIcon} className="chip__iconclose"/>
              </div>
            ))
          }
          <input
            id={props.name}
            className={props.inputClassname ?? "chip__input text-field"}
            autoComplete={props.autoComplete ?? 'off'}
            type={props.type}
            value={props.value}
            onChange={handleChange}
            onKeyDown={handleChipsSeparator}
            name={props.name}
            maxLength={props.maxLength || 50}
            placeholder={props.placeholder}
            disabled={props.disabled || chips?.length >= maxChips}
            onBlur={props.onBlur}     
            accept={props.accept}             
          />
        </div>
      </Tooltip>
      {props.error &&
        <p className='alert s'>{props.error}</p>
      }
      {props.helperText &&
        <div style={{maxWidth: 380, fontSize: 11}} className='alert-info-text'>
            {props.helperText}
        </div>
      }
    </div>
  )
}